/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as AccessDefs from "./defs.defs.js";

const $nsid = "place.stream.access.listGrants";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"role":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"grants":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<AccessDefs.GrantView>((() => AccessDefs.grantView) as any), )});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** List every grant on this node, including grants seeded from the environment. Requires the admin role. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["Unauthorized"]);

export { main };

export const $lxm = $nsid;
